export function formatEuro(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return "-";
  const rounded = Math.round(Number(n) * 10) / 10;
  return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)} €`;
}
